import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withKeys as _withKeys, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e0d281c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-patient" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_icon_template = _resolveComponent("icon-template")!
  const _component_e_searched_patient_card = _resolveComponent("e-searched-patient-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isPatientSearched)
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 0,
          modelValue: _ctx.searchingData,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchingData) = $event)),
          class: "search-patient__search",
          placeholder: "Поиск по фамилии/№ медкарты",
          filterable: "",
          remote: "",
          "no-data-text": "Пациенты не найдены",
          "remote-method": _ctx.remotePatientSearch
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patients, (patient) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: _ctx.getOptionLabel(patient),
                value: patient.name,
                onClick: ($event: any) => (_ctx.getPatient(patient.id)),
                onKeydown: _withKeys(($event: any) => (_ctx.getPatient(patient.id)), ["enter"])
              }, null, 8, ["label", "value", "onClick", "onKeydown"]))
            }), 256))
          ]),
          _: 1
        }, 8, ["modelValue", "remote-method"]))
      : (_openBlock(), _createBlock(_component_e_searched_patient_card, {
          key: 1,
          class: "search-patient__patient",
          patient: _ctx.selectedPatient
        }, {
          remove: _withCtx(() => [
            _createVNode(_component_icon_template, {
              class: "search-patient__patient-remove",
              name: "remove",
              width: "10",
              height: "10",
              onClick: _ctx.handleRemovePatient
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["patient"]))
  ]))
}